import cn from 'classnames'
import { JSX } from 'react'

import { ISobCompetitorsDependOnSettings } from 'partner360/models/ISobCompetitorsDependOnSettings'
import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

import styles from './SobCompetitorItems.module.scss'

interface ICompetitorItemsProps {
  item: ISobCompetitorsGroup
  renderContent: (comp: ISobCompetitorsDependOnSettings) => JSX.Element
  isDisplaySellThru: boolean
  useColumnWidth?: boolean
}

export const SobCompetitorItems = ({
  item,
  renderContent,
  isDisplaySellThru,
  useColumnWidth = true,
}: ICompetitorItemsProps) => {
  return (
    <div className={styles.itemsContainer}>
      {item.Items.map((comp, index) => (
        <div
          className={cn(styles.item, { [styles.item__onlySob]: !isDisplaySellThru })}
          key={index}
        >
          {renderContent(comp)}
        </div>
      ))}
    </div>
  )
}
